import idsTokensDefault from '../../utils/tokens/idsTokens';

export const classes = (idsTokens = idsTokensDefault) => ({
  root: {
    boxShadow: 'none',
    minWidth: idsTokens.accordion.default.spacing.standard.collapsed.min.width,
    minHeight: idsTokens.accordion.default.spacing.standard.collapsed.min.height,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
    '&.MuiPaper-root.MuiAccordion-root': {
      minHeight: 'unset',
    },
    '&.MuiPaper-root.MuiAccordion-root.Mui-disabled': {
      opacity: 1,
    },
    '&.Mui-disabled': {
      backgroundColor: 'unset',
      '& .MuiAccordionSummary-root': {
        '&.MuiButtonBase-root': {
          opacity: 1,
        },
        background: idsTokens.accordion.default.color.header.collapsed.background.disabled,
        color: idsTokens.accordion.default.color.header.text.disabled,
        borderBottom: `1px solid ${idsTokens.accordion.default.color.divider.disabled}`,
        '& .MuiAccordionSummary-content > .MuiTypography-root:nth-of-type(2)': {
          color: idsTokens.accordion.default.color.sublabel.disabled,
        },
        '&.Mui-expanded': {
          background: idsTokens.accordion.default.color.expanded.background.disabled,
          color: idsTokens.accordion.default.color.header.text.disabled,
          borderBottom: `1px solid ${idsTokens.accordion.default.color.divider.disabled}`,
        },
      },
      '& .MuiAccordionDetails-root': {
        backgroundColor: idsTokens.accordion.default.color.body.background.disabled,
      },
    },
    '&::before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: '0',
      minWidth: idsTokens.accordion.default.spacing.standard.expanded.min.width,
      minHeight: idsTokens.accordion.default.spacing.standard.expanded.min.height,
    },
    '&.MuiPaper-elevation1': {
      borderWidth: '0 0 0 0',
    },
    '.MuiAccordionSummary-expandIconWrapper': {
      position: 'absolute',
      color: 'inherit',
      right: 'unset',
      top: 24,
      left: -4,
      transform: 'translateY(-50%) rotate(-90deg)',
      '&.Mui-expanded': {
        transform: 'translateY(-50%) rotate(0deg)',
      },
    },
    '& .MuiCollapse-root': {
      width: '100%',
      minWidth: idsTokens.accordion.default.spacing.standard.expanded.body.min.width,
      minHeight: idsTokens.accordion.default.spacing.standard.expanded.body.min.height,
    },
    '& .MuiAccordion-heading': {
      width: '100%',
    },
  },
});
